module.exports = __webpack_public_path__ + "static/media/birzeit_logo.b3de79e8.png";